import { carouselItems } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">热门专题</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            编辑精选热门漫画专题，一站式了解当下最火作品
          </p>
        </div>

        <div className="space-y-6">
          {carouselItems.map((item, idx) => (
            <div
              key={item.id}
              className={`flex flex-col ${idx % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-6 md:gap-10 bg-background-100 rounded-2xl border border-background-200 overflow-hidden p-5 md:p-8`}
            >
              <div className="flex-1 flex flex-col justify-center">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3 w-fit">
                  {item.tag}
                </span>
                <h3 className="text-xl md:text-2xl font-heading text-foreground-950 mb-3">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                  {item.desc}
                </p>
                <div className="flex items-center gap-4">
                  <span className="text-xs text-foreground-400">
                    <i className="ri-eye-line mr-1"></i>点阅量 {item.views}
                  </span>
                  <a
                    href="#cards"
                    className="inline-flex items-center gap-1.5 text-sm text-primary-500 font-medium hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    查看详情 <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
              <div className="flex-1 min-h-[200px] md:min-h-[280px]">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover rounded-xl"
                  loading="lazy"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}